export const set = property => (state, payload) => (state[property] = payload)

export const toggle = property => state => (state[property] = !state[property])

export const __tokenName = 'polaznicki_portal_web_api_spa_token';




// WEBPACK FOOTER //
// ./VueSrc/Common/Store/app/utils/vuexutils.js